import { Popper as MuiPopper, PopperProps } from '@mui/material';
import React from 'react';


const modifiers = [
  {
    name: 'flip',
    enabled: false,
    options: {
      altBoundary: true,
      rootBoundary: 'viewport',
      padding: 8,
    },
  },
  {
    name: 'preventOverflow',
    enabled: false,
    options: {
      altAxis: true,
      altBoundary: true,
      tether: true,
      rootBoundary: 'viewport',
      padding: 8,
    },
  },
  {
    name: 'arrow',
    enabled: false,
  },
]

const Popper = (props: PopperProps) => {
  return (
    <MuiPopper
      {...props}
      placement="bottom"
      disablePortal={true}
      modifiers={modifiers}
    />
  );
};

export default Popper;
